import React from "react";
import ReactDOM from "react-dom/client";
import {
  QueryClient,
  QueryClientProvider,
} from '@tanstack/react-query';
import "@fontsource/inter";
import "@fontsource/inter/500.css";
import "@fontsource/inter/600.css"
import "./index.css";
import { BrowserRouter, ScrollRestoration } from "react-router-dom";
import reportWebVitals from "./reportWebVitals";
import Main from "./main-wrapper/Routes";
import { WorkspaceProvider } from "./context/WorkspaceContext";
import { Toaster } from 'react-hot-toast';

// Remove ghost service worker
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    for (const registration of registrations) {
      console.warn('Found ghost service worker, killing it:', registration);
      registration.unregister();
    }
  });
}

// Handle resource loading errors
window.addEventListener('error', (event) => {
  // Check if the error is from a script or link tag (indicates failed resource loading)
  const target = event.target as HTMLElement;
  if (target && (target.tagName === 'SCRIPT' || target.tagName === 'LINK')) {
    console.error('Resource loading failed (likely due to deployment), forcing reload...');

    // Prevent infinite reload loop: check SessionStorage
    if (!sessionStorage.getItem('force_reloaded')) {
      sessionStorage.setItem('force_reloaded', 'true');
      // Force browser reload, this will fetch the new index.html with no-store
      window.location.reload();
    }
  }
}, true);

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
const queryClient = new QueryClient();

root.render(
  <QueryClientProvider client={queryClient}>
    <WorkspaceProvider>
      <BrowserRouter>
        <Main />
      </BrowserRouter>
    </WorkspaceProvider>
    <Toaster position="top-center" />
  </QueryClientProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
